import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SITE_DEFAULTS } from "@/config/site";

let cache = null;
let pending = null;

const load = () => {
  pending = pending || api.get("/settings")
    .then((r) => { cache = { ...SITE_DEFAULTS, ...r.data, media: { ...(r.data.media || {}) } }; return cache; })
    .catch(() => { pending = null; return SITE_DEFAULTS; });
  return pending;
};

export function useSettings() {
  const [s, setS] = useState(cache || SITE_DEFAULTS);
  useEffect(() => {
    if (cache) return;
    let alive = true;
    load().then((v) => { if (alive) setS(v); });
    return () => { alive = false; };
  }, []);
  return s;
}
